


















































































import {Component, Prop, Vue} from 'vue-property-decorator';
import Course from '@/logic/course';
import App from '@/components/app/app';
import {GPAUtils} from '@/logic/utils/gpa-utils';
import Constants from '@/constants';
import {RATING_CRITERIA} from '@/logic/course-info';
import Navigation from '@/components/navigation/navigation';

@Component
export default class CourseHead extends Vue
{
    @Prop({required: true}) unread: number;
    @Prop({required: true}) course: Course;
    @Prop({required: true}) clickable: boolean;

    ratingDialog = false;
    ratingPosting = false;
    rating = this.course.rating;

    get canSubmit()
    {
        return this.ratingPosting || App.instance.demoMode
    }

    /**
     * Redirect to the course page
     */
    redirect()
    {
        if (!this.clickable) return;
        App.instance.nav.updateIndex(this.course.urlIndex);
    }

    /**
     * Display rate button or not
     */
    get displayRate()
    {
        return this.clickable && App.instance.showRating;
    }

    get ratingCriteria() {return RATING_CRITERIA}

    /**
     * Change star rating data
     *
     * @param index Index of the rating
     * @param star Change to how many stars
     */
    changeStars(index: number, star: number)
    {
        this.rating.ratings[index] = star + 1;
        this.$forceUpdate();
    }

    /**
     * Submit a rating
     */
    submitRating()
    {
        if (this.rating.ratings.includes(0))
        {
            this.$message.error('You haven\'t rated all of the criteria yet!');
            return;
        }

        this.ratingPosting = true;

        App.http.post('/course-info/rating/set', {rating: this.rating}).then(response =>
        {
            if (response.success)
            {
                this.ratingDialog = false;
                this.ratingPosting = false;
                this.$message.success('Rating successfully posted, thank you!');

                // First rating (Updating the first review doesn't count as first review)
                if (this.course.rated) return;
                this.course.rated = true;
                if (App.instance.courses.filter(c => c.rated).length == 1)
                {
                    this.$alert('You can view other courses\'' +
                        ' ratings in the Course Selection tab, or review yours by clicking' +
                        ' the green button that says "Rating Entered." There are also option to turn off the rating buttons ' +
                        ' by clicking on your avatar on the top right corner.',
                        'Thank you for submitting your fist rating!', {confirmButtonText: 'OK'}
                    );
                }

                // Last rating
                if (App.instance.courses.filter(c => c.isGraded && !c.rated).length == 0)
                {
                    this.$confirm('You have rated all of your courses! Do you want to turn off the rating buttons?' +
                        ' (there are option to toggle them on again by clicking your avatar on the top right corner.)',
                        'Thank you for submitting rating!',
                        {confirmButtonText: 'Sure!', cancelButtonText: 'Nope.'}).then(() =>
                    {
                        // Disable rating buttons
                        Navigation.instance.onAvatarMenu('switch-rating');
                        this.$message.success('Rating buttons are disabled');
                    });
                }
            }
            else
            {
                this.$message.error('Sorry, but rating failed to post, please try again or email me if you continues to have issues. ' +
                        'But wait! The email system isn\'t created yet... oops!. (Technical error message: ' + response.data + ')');
                this.ratingPosting = false;
            }
        });
    }
}
